import { mount } from './bootstrap';
const container = document.getElementById('root');
if (container) {
    mount(container);
}
